import { Component, OnInit, inject, input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { Stats } from '../models/stats';
import { RoutesService } from '../../shared/services/routes.service';

@Component({
  selector: 'app-stats',
  standalone: true,
  imports: [CardModule, ButtonModule],
  templateUrl: './stats.component.html',
  styleUrl: './stats.component.css'
})
export class StatsComponent implements OnInit {
  protected routesService = inject(RoutesService)
  statsNotFound = {
    content: {
      title: 'Title',
      value: 'Value',
      button: {
        icon: 'pi pi-chart-bar',
        color: 'bg-blue-100 text-blue-500'
      }
    },
    value: '123',
    comment: 'This is a comment'
  }
  stats = input<Stats | undefined>(this.statsNotFound)

  ngOnInit(): void {}
}
